import React from 'react';

/**
 * Role-specific quick-prompt chips shown when the conversation is empty.
 * Clicking a chip immediately sends that prompt.
 */
const CapabilityChips = ({ examples, roleColor, onPick }) => {
  if (!examples || examples.length === 0) return null;

  return (
    <div className="chatbot-chips-container">
      {examples.map((example, i) => (
        <button
          key={i}
          className="chatbot-chip"
          style={{ borderColor: roleColor, color: roleColor }}
          onClick={() => onPick(example)}
        >
          {example}
        </button>
      ))}
    </div>
  );
};

export default CapabilityChips;
